module.exports = __webpack_public_path__ + "img/works_feilang_go_4.c5419615.png";